import { render, staticRenderFns } from "./PopupView.vue?vue&type=template&id=472b96be"
import script from "./PopupView.vue?vue&type=script&lang=ts&setup=true"
export * from "./PopupView.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports